import { render, staticRenderFns } from "./TaxGuideAlert.vue?vue&type=template&id=07e49e25&"
import script from "./TaxGuideAlert.vue?vue&type=script&lang=js&"
export * from "./TaxGuideAlert.vue?vue&type=script&lang=js&"
import style0 from "./TaxGuideAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
